import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Text from '@zenbusiness/zui/Text';

const SUCCESS_ILLUSTRATION = 'https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/s2/raster/successful.png';
const ERROR_ILLUSTRATION = 'https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/s2/raster/error-page.png';

const buttonRowSx = (theme) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  '& > *': { width: '100%' },
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    '& > *': { width: 'auto' },
    '& > :first-of-type': { order: 2 },
    '& > :last-child': { order: 1 }
  }
});

export function SubscriptionCancelResult({
  success,
  onReturnToSubscriptions,
  onReturnToDashboard,
  onContactUs
}) {
  const { formatMessage } = useIntl();

  return (
    <>
      <Box display="flex" justifyContent="center">
        <SharedAsset
          alt=""
          src={success ? SUCCESS_ILLUSTRATION : ERROR_ILLUSTRATION}
          sx={{ width: { xs: 160, sm: 220 } }}
        />
      </Box>

      <Box display="flex" flexDirection="column" gap={1.5} textAlign="center">
        <Text size="2xl" weight="bold" family="secondary">
          {success
            ? formatMessage({ id: 'dashboard.subscriptionCancel.result.success.heading' })
            : formatMessage({ id: 'dashboard.subscriptionCancel.result.error.heading' })}
        </Text>
        <Text size="md" color="text.secondary">
          {success
            ? formatMessage({ id: 'dashboard.subscriptionCancel.result.success.body' })
            : formatMessage({ id: 'dashboard.subscriptionCancel.result.error.body' })}
        </Text>
      </Box>

      {success ? (
        <Box sx={buttonRowSx}>
          <Button variant="contained" size="large" onClick={onReturnToSubscriptions}>
            {formatMessage({ id: 'dashboard.subscriptionCancel.result.returnToSubscriptions' })}
          </Button>
          <Button variant="outlined" size="large" onClick={onReturnToDashboard}>
            {formatMessage({ id: 'dashboard.subscriptionCancel.result.returnToDashboard' })}
          </Button>
        </Box>
      ) : (
        <Box sx={buttonRowSx}>
          <Button variant="contained" size="large" onClick={onContactUs}>
            {formatMessage({ id: 'dashboard.subscriptionCancel.result.contactUs' })}
          </Button>
          <Button variant="outlined" size="large" onClick={onReturnToSubscriptions}>
            {formatMessage({ id: 'dashboard.subscriptionCancel.result.returnToSubscriptions' })}
          </Button>
        </Box>
      )}
    </>
  );
}

SubscriptionCancelResult.propTypes = {
  success: PropTypes.bool.isRequired,
  onReturnToSubscriptions: PropTypes.func.isRequired,
  onReturnToDashboard: PropTypes.func.isRequired,
  onContactUs: PropTypes.func.isRequired
};
